module.exports = __webpack_public_path__ + "img/food-20.57603958.jpg";